export enum Currency {
  ArgentinePeso = 'ARS',
  AustralianDollar = 'AUD',
  BelarusianRuble = 'BYR',
  BrazilianReal = 'BRL',
  BritishPound = 'GBP',
  BulgarianLev = 'BGN',
  CanadianDollar = 'CAD',
  ChileanPeso = 'CLP',
  ChineseYuan = 'CNY',
  ColombianPeso = 'COP',
  CroatianKuna = 'HRK',
  CzechKoruna = 'CZK',
  DanishKrone = 'DKK',
  EstonianKroon = 'EEK',
  Euro = 'EUR',
  HungarianForint = 'HUF',
  IcelandicKrona = 'ISK',
  IndianRupee = 'INR',
  JapaneseYen = 'JPY',
  KazakhstaniTenge = 'KZT',
  LatvianLats = 'LVL',
  LithuanianLitas = 'LTL',
  MexicanPeso = 'MXN',
  MoldovanLeu = 'MDL',
  MongolianTugrik = 'MNT',
  NewTaiwanDollar = 'TWD',
  NewZealandDollar = 'NZD',
  NorwegianKrone = 'NOK',
  ParaguayanGuarani = 'PYG',
  PeruvianSol = 'PEN',
  PhilippinePeso = 'PHP',
  PlayMoney = 'PFF',
  PolishZloty = 'PLN',
  RomanianLeu = 'RON',
  RussianRuble = 'RUB',
  SerbianDinar = 'RSD',
  SlovakKoruna = 'SKK',
  SouthAfricanRand = 'ZAR',
  SwedishKrona = 'SEK',
  SwissFranc = 'CHF',
  ThaiBaht = 'THB',
  USDollar = 'USD',
  UkrainianHryvnia = 'UAH',
  UruguayanPeso = 'UYU'
}
